export const GET_UNIV_VIDEOS = "GET_UNIV_VIDEOS";
export const RESET_UNIV_VIDEOS = "RESET_UNIV_VIDEOS";
export const SET_UNIV_VIDEOS_REQUEST_STATUS = "SET_UNIV_VIDEOS_REQUEST_STATUS";
